<template>
    <div>
      <AddDebitorDlg ref="addDebitorDlg" v-on:Accepted="AddDebitorAccepted"></AddDebitorDlg>
      <vs-prompt
      @cancel="canceld"
      @accept="accepted"
      @close="closed"
      :active.sync="dlgActive"
      :title="popupTitle"
      :accept-text="$t('COM.SAVE')"
      :cancel-text="$t('COM.CANCEL')"
      id="promptAddPartnerOrder"
      :is-valid="formValid">
       <div>
        <div>
          <p>{{$t('PARTNERORDER.ADD_ORDER.HEADER.TEXT')}}</p>
          <div class="default-input d-flex align-items-center">{{$t('PARTNERORDER.ADD_ORDER.ORDER_NUMBERGROUP')}} 
            <vs-select :disabled="order_nr.length > 0" v-model="numbergroup_fk" class="ml-2" :danger="numbergroup_fk_fail">
              <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in numbergroups" />
            </vs-select>
          </div>
          <div class="default-input d-flex align-items-center mt-2 mb-2">{{$t('PARTNERORDER.ADD_ORDER.ORDER_COMPANY')}} 
            <vs-select :disabled="order_nr.length > 0" v-model="base_company_fk" class="ml-2" :danger="base_company_fk_fail">
              <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in baseCompanies" />
            </vs-select>
          </div>
          <div class="default-input d-flex align-items-center mb-3 mt-2">
            <vs-input ref="bez" :label="$t('PARTNERORDER.ADD_ORDER.LABEL.BEZ')"  class="float-left mr-2 inputx" :placeholder="$t('PARTNERORDER.ADD_ORDER.LABEL.PLACEHOLDER.BEZ')"  v-model="bez" :danger="bez_fail" val-icon-danger="clear"/>
          </div>
          <div class="default-input d-flex align-items-center mb-3 mt-2">
            <vs-textarea height="200px" counter="250" :label="$t('PARTNERORDER.ADD_ORDER.ZUSATZINFO')" v-model="infotext" />
          </div>
          <div class="default-input d-flex align-items-center mb-3 mt-2">
                <vs-checkbox v-model="showDebitor">{{$t('PARTNERORDER.ADD_ORDER.SEND_TO_DEBITOR')}}</vs-checkbox>
          </div>
          <div v-if="showDebitor">
            <div class="clearfix" >
              <div class="float-left p-3" id="oldDeb">
                <h5 class="mb-2">{{$t('DEBITORCONTACT.SELECT_DEB')}}</h5>
                <vs-select v-model="debitor_fk" autocomplete class="float-right" :disabled="!showDebitor" :label="$t('DEBITORCONTACT.TYPE_SEARCH')">
                  <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in debitors" />
                </vs-select>
              </div>
              <div class="float-left p-3"> 
                <h5 class="mb-2">{{$t('DEBITORCONTACT.NEW_DEB')}}</h5>
                <vs-button :disabled="!showDebitor" type="filled" icon="add"  @click="$refs.addDebitorDlg.showDlg()" >{{$t('DEBITORCONTACT.ADD_DEBITOR')}}</vs-button>
              </div>
              
            </div>
            <vs-checkbox class="mt-2 mb-1" v-model="dsgvoCheck">{{$t('PARTNERORDER.ADD_ORDER.DSGVO')}}</vs-checkbox>
            <p id="dsgvo_txt">{{$t('PARTNERORDER.ADD_ORDER.DSGVO_TXT')}}</p>
          </div>
        </div>
       </div>
     </vs-prompt>
    </div>
</template>
<script>

import helperMethods from '../../../helper/staticFuncHelper';
import codeHelper from '../../../helper/staticCodeHelper';
import enumHelper from '../../../helper/enumHelper';
import {numbergroup_Types} from '../../../helper/enumHelper';
import AddDebitorDlg from './AddDebitorDlg';

export default {
  name: "AddPartnerOrderDlg",
  props:[],
  components:{
    AddDebitorDlg
  },
  data: function (){
     return {
      dlgActive:false,
      numbergroups:[],
      popupTitle:this.$t('PARTNERORDER.ADD_ORDER.TITLE'),
      country_fk:-1,
      order_nr:"",
      numbergroup_fk:-1,
      numbergroup_fk_fail:false,
      numbergroup_fk_ok:false,
      currency_fk:-1,
      bez:"",
      bez_fail:false,
      bez_ok:false,
      defaultNrGrpFk:-1,
      company_fk: 0,
      base_company_fk: -1,
      base_company_fk_fail:false,
      base_company_fk_ok:false,
      id:0,
      member:[],
      state:0,
      from_offer_fk: 0,
      debitor_fk:0,
      showDebitor:false,
      dsgvoCheck:false,
      infotext:""
    }
  }, 
  mounted () {
    this.$store.dispatch('numbergroup/getNumbergroupsByCompany',0,{ root: true });
    this.ClearForm();
    
  },
  methods:{
      ...helperMethods,
      ...codeHelper,
      ...enumHelper,
      ShowDlg(){
        this.ClearForm();
        this.$store.dispatch('company/getCompaniesOrderPossible');
        
        if(this.defaultNrGrpFk != -1)
        {
          this.numbergroup_fk = this.defaultNrGrpFk;
        }        
        this.dlgActive=true;

      },
      ShowDlgFromPrices(member){
        this.ClearForm();
        this.$store.dispatch('company/getCompaniesOrderPossible');
        
        if(this.defaultNrGrpFk != -1)
        {
          this.numbergroup_fk = this.defaultNrGrpFk;
        }
        this.member = member;        
        this.dlgActive=true;

      },      
      ShowDlgFromOffer(offer_fk){
        this.ClearForm();
        this.$store.dispatch('company/getCompaniesOrderPossible'); 
        
        if(this.defaultNrGrpFk != -1)
        {
          this.numbergroup_fk = this.defaultNrGrpFk;
        }        
        this.from_offer_fk = offer_fk;
        this.dlgActive=true;

      },
      closed(){
        this.ClearForm();
      },
      InitDlgData(data){
        this.ClearForm();
        if(this.IsNotNull(data))
        {
          this.id = data.id;
          this.country_fk = data.country_fk;
          this.order_nr = data.order_nr;
          this.numbergroup_fk = data.numbergroup_fk;
          this.currency_fk = data.currency_fk;
          this.bez = data.bez;
          this.company_fk = data.company_fk;
          this.base_company_fk = data.base_company_fk;
          this.member = data.member;
          this.state = data.state;

          this.popupTitle = this.$t('PARTNERORDER.ADD_ORDER.TITLE.EDIT') + ' ('+this.order_nr+')';

          this.dlgActive=true;
        }
      },
      AddDebitorAccepted(id){
        this.debitor_fk = id;
      },      
      accepted(){

          var order = {
            bez:this.bez,
            company_fk: this.company_fk,
            base_company_fk: this.base_company_fk,
            country_fk:this.country_fk,
            currency_fk:this.currency_fk,
            numbergroup_fk:this.numbergroup_fk,
            id:this.id,
            member:this.member,
            state:this.state,
            order_nr:this.order,
            from_offer_fk:this.from_offer_fk,
            debitor_fk:this.debitor_fk,
            dsgvoCheck:this.dsgvoCheck,
            infotext:this.infotext
          };

          var name = this.bez;
          this.$store.dispatch('partnerorder/savePartnerOrder', order)
          .then(response => {
            if(response.success === true)
            {
                this.$store.dispatch('alertqueue/addSuccess', {'titel':this.$t('COM.SUCCESS.TITEL'),'text':this.$t('PARTNERORDER.ADD_ORDER.SUCCESS.SAVE').replace("*1*",name)});  
                this.$emit('Success',response.id);
            }
            else
            {
              var text = this.$t('PARTNERORDER.ADD_ORDER.WARNING.SAVE').replace("*1*",name);
              text = text.replace("*2*",this.$t(response.text));
              this.$store.dispatch('alertqueue/addWarning', {'titel':this.$t('COM.WARNING.TITEL'),'text':text}); 
            }
            
          }, 
          error =>{
              var text = this.$t('PARTNERORDER.ADD_ORDER.ERROR.SAVE').replace("*1*",name);
              text = text.replace("*2*",error);
              this.$store.dispatch('alertqueue/addError', {'titel':this.$t('COM.ERROR.TITEL'),'text':text});  
          });

          this.ClearForm();
      },
      canceld(){
        this.ClearForm();
      },
      ClearForm(){ 
        this.country_fk = -1;
        this.order_nr = "";
        this.numbergroup_fk = -1;
        this.currency_fk = -1;
        this.bez = "";
        this.numbergroup_fk_fail = false;
        this.numbergroup_fk_ok = false;
        this.bez_fail = false;
        this.bez_ok = false;
        this.company_fk = 0;
        this.base_company_fk = -1;
        this.id = 0;
        this.state = 0;
        this.debitor_fk = 0;
        this.member = [];
        this.showDebitor = false;
        this.dsgvoCheck=false;
        this.infotext = "";
      }
  },
  computed:{
    formValid(){
      let ok = this.bez_ok && this.numbergroup_fk_ok;

      if(this.showDebitor )
      {
        ok &= this.dsgvoCheck && this.debitor_fk > 0;
      }

      return ok;
    },
    numbergroupsForSelect(){
      return this.GetListOfNumbergroupsForSelect(numbergroup_Types.BESTELLUNG);
    },
    baseCompanies(){
      return this.GetListOfCompaniesOrderPossibleForSelect();
    },
    debitors(){
      return this.GetListOfDebitorsForSelect();
    },
  },
  watch:{
    numbergroupsForSelect(value)
    {
        this.numbergroups = value.numbergroups;
        this.defaultNrGrpFk = value.default;
    },
    bez(value)
    {
      this.bez_fail = value.length == 0;
      this.bez_ok = !this.bez_fail;
    },
    numbergroup_fk(value){
      this.numbergroup_fk_fail = value <= 0;
      this.numbergroup_fk_ok = !this.numbergroup_fk_fail;
    },
  }
};
</script>
<style>
div#promptAddPartnerOrder > div.vs-dialog{
  max-width: 800px !important;
}
div#promptAddPartnerOrder > div.vs-dialog > 
div.vs-dialog-text > div > div > 
div.vs-tabs > div.con-slot-tabs > div.vs-tabs--content{
min-height: 450px;
}
p#dsgvo_txt{
  text-align: center;
}
</style>